<template>
   <!-- Diálogo de Pesquisa NPS (Ativo até 11/11) -->
   <v-dialog 
     v-if="isTemfcUser && isNpsActive"
     v-model="showNpsDialog" 
     max-width="520" 
     persistent>
     <v-card class="pa-0 rounded-xl overflow-hidden" elevation="10" style="background: #ffffff; border: 1px solid rgba(49, 95, 216, 0.15); border-radius: 20px !important;">
       <!-- Banner superior -->
       <div class="px-6 py-5 text-center position-relative" style="background: linear-gradient(135deg, #051946 0%, #17387e 50%, #315fd8 100%); color: #ffffff;">
         <v-btn 
           icon 
           variant="text" 
           size="small" 
           style="position: absolute; top: 12px; right: 12px; color: rgba(255, 255, 255, 0.8);" 
           @click="dismissNpsDialog"
           aria-label="Fechar"
         >
           <v-icon size="20">mdi-close</v-icon>
         </v-btn>

         <h2 style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.45rem; font-weight: 700; line-height: 1.3; margin: 0; color: #ffffff;">
           Você recomendaria a Veri Salvatori?
         </h2>
         <div class="mt-1" style="font-size: 0.85rem; color: rgba(255, 255, 255, 0.85); font-weight: 500; letter-spacing: 0.03em; text-transform: uppercase;">
           Pesquisa de Satisfação
         </div>
       </div>

       <!-- Texto informativo -->
       <v-card-text class="pa-6 text-center" style="font-size: 1.05rem; line-height: 1.6; color: #334155;">
         <p class="mb-2" style="font-size: 1.1rem; font-weight: 600; color: #1e293b;">
           Leva menos de 1 minuto.
         </p>
         <p class="mb-0" style="font-size: 0.98rem; color: #64748b;">
           É só dar uma nota e deixar sua sugestão para continuarmos evoluindo sua experiência.
         </p>

         <div class="d-flex justify-center align-center mt-4 py-2 px-3 rounded-lg" style="background: #f8fafc; border: 1px dashed rgba(49, 95, 216, 0.2);">
           <v-icon v-for="i in 5" :key="i" color="#f59e0b" size="22" class="mx-1">mdi-star</v-icon>
         </div>
       </v-card-text>

       <!-- Ações -->
       <v-card-actions class="px-6 pb-6 pt-0 d-flex flex-column align-center">
         <v-btn 
           color="primary" 
           variant="elevated"
           class="vs-btn-primary mb-2" 
           style="width: 100%; height: 46px; font-size: 1rem; color: white !important; font-weight: 700; border-radius: 12px; text-transform: none; letter-spacing: 0.02em;" 
           @click="respondNpsNow">
           <v-icon left class="mr-2">mdi-open-in-new</v-icon>
           Responder agora
         </v-btn>
         <v-btn 
           variant="text" 
           style="color: #64748b; font-weight: 600; font-size: 0.9rem; text-transform: none;" 
           @click="dismissNpsDialog">
           Agora não
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

   <!-- Diálogo do desafio de 150 questões (Reativado após 11/11 se aplicável) -->
   <v-dialog 
     v-if="isTemfcUser && !isNpsActive"
     v-model="showChallengeDialog" 
     max-width="800" 
     persistent>
        <v-card class="pa-4">
          <!-- Banner superior com cor vibrante -->
          <v-card-title class="text-center py-4" style="background: linear-gradient(135deg, #05122e 0%, #0d286d 100%); color: #fafaff; font-weight: 700; font-size: 1.35rem; font-family: 'Roboto Condensed', sans-serif; letter-spacing: 0.02em;">
            🚀 Participe do Desafio 150 Questões!
          </v-card-title>

          <!-- Texto informativo com destaque -->
          <v-card-text class="text-center" style="font-size: 1.1rem; line-height: 1.6;">
            <p>Complete o desafio para revisar os principais conteúdos! São 150 questões para uma revisão completa.</p>
          </v-card-text>

          <!-- Ação com botões centralizados -->
          <v-card-actions class="justify-center">
            <v-btn 
              color="primary" 
              variant="elevated"
              class="mx-2 vs-btn-primary" 
              style="color: white !important; font-weight: bold;" 
              @click="$router.push('/webapp/questionschallenge')">
              🌟 Participar
            </v-btn>
            <v-btn 
              color="secondary" 
              class="mx-2" 
              style="font-weight: bold;" 
              @click="showChallengeDialog = false">
              ❌ Agora Não
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  <v-dialog v-model="loading" max-width="300" persistent>
    <v-card elevation="12" class="text-center" color="white" style="border-radius: 16px;">
      <v-card-text class="pa-8">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-4"></v-progress-circular>
        <div class="font-weight-bold text-h6" style="color: #315fd8; font-family: 'Roboto Condensed', sans-serif;">Carregando...</div>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Adicione o diálogo para a sugestão Resetar Questoes -->
  <v-dialog v-model="showQuestionResetDialog" max-width="500">
    <v-card>
      <v-card-title>Limpar Histórico de Questões</v-card-title>
      <v-card-text class="text-justify">
        Ao confirmar, seu histórico de questões resolvidas e erradas será zerado. Isso fará com que todas as questões voltem a ser consideradas "inéditas" nos filtros. Sua contagem total de questões resolvidas nas estatísticas permanecerá inalterada.
      </v-card-text>
      <v-card-actions>
        <!-- Adicione botões para salvar e fechar o diálogo -->
        <v-btn @click="saveQuestionReset" color="primary" text class="ml-auto">Limpar Histórico</v-btn>
        <v-btn @click="closeSuggestionDialog" color="red" text>Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Novo Diálogo para a redefinição -->
  <v-dialog v-model="resetting" max-width="400" persistent>
          <v-card>
            <v-card-title>Salvando dados.</v-card-title>
            <v-card-text>
              <!-- Conteúdo do diálogo de redefinição -->
              Aguarde enquanto seus dados estão sendo salvos...
            </v-card-text>
          </v-card>
        </v-dialog>

  <!-- Diálogo para quando não há questões disponíveis -->
<v-dialog v-model="showNoQuestionsDialog" max-width="400">
    <v-card style="border-radius: 16px;" class="text-center pa-4">
      <v-card-text class="pa-6">
        <v-icon size="64" color="amber darken-2" class="mb-4">mdi-star-face</v-icon>
        <div class="text-h5 font-weight-bold mb-2">⭐ Parabéns!</div>
        <div class="text-body-1 grey--text text--darken-2">
          {{ noQuestionsMessage }}
        </div>
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn color="primary" variant="elevated" class="vs-btn-primary text-none font-weight-bold" block style="border-radius: 8px; height: 42px; color: white !important;" @click="closeNoQuestionsDialog">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container v-if="!quizstart">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
            <!-- <v-chip
              class="ma-2"
              color="blue"
              label
              text-color="white"
              v-bind="props"
              v-on="on"
            >
              <v-icon left>mdi-label</v-icon>
              {{ String(noqdName) }} / {{ String(noqName) }} questões completas.
            </v-chip> -->
            <v-btn
              icon
              v-on="on"
              @click="openQuestionResetDialog"
              class="ml-auto mb-3"
              style="
                padding: 4px;
                border-radius: 4px;
                max-width: 30px;
                max-height: 30px;
                background-color: rgba(255, 0, 0, 0.1);
              "
            >
              <v-icon color="red" size="18">mdi-file-restore</v-icon>
            </v-btn>


        <v-card elevation="0" style="border-radius: 16px; border: 1px solid rgba(49, 95, 216, 0.12); box-shadow: 0 8px 32px rgba(3, 10, 26, 0.05); background: #ffffff;">
          <v-card-title
            class="headline text-center font-weight-bold pl-10 pr-10 pt-10 mb-0"
            style="color: #051946; font-family: 'Roboto Condensed', sans-serif; font-size: 1.6rem; letter-spacing: -0.01em; white-space: normal; word-break: break-word; overflow-wrap: break-word;"
          >
            Iniciar Questões {{ displayDbName }}
          </v-card-title>

          <v-text-field
            v-model.number="selectedNumberOfQuestions"
            label="Escolha o número de questões que gostaria de fazer (1-90)"
            type="number"
            min="1"
            max="90"
            density="compact"
            class="pl-10 pr-10 pt-0 mx-auto"
          ></v-text-field>

          <v-autocomplete
            v-model="selectedTheme"
            :items="themeOptions"
            label="Escolha o(s) tema(s)"
            multiple
            clearable
            searchable
            style="width: 100%;"
            class="pl-10 pr-10 pt-3 mx-auto"
            @update:model-value="handleThemeSelectionChange"
            placeholder="Selecione ou digite um tema..."
            chips
            closable-chips
            :menu-props="{ maxHeight: '300px', width: '300px' }"
          ></v-autocomplete>

          <v-autocomplete
            v-model="selectedSubTheme"
            :items="loadSubThemes"
            label="Escolha o(s) subtema(s)"
            multiple
            clearable
            searchable
            style="width: 100%;"
            class="pl-10 pr-10 pt-3 mx-auto"
            @update:model-value="handleSubThemeSelectionChange"
            placeholder="Selecione ou digite um subtema..."
            chips
            closable-chips
            :menu-props="{ maxHeight: '300px', width: '300px' }"
          ></v-autocomplete>

          <v-select
            v-model="selectedMode"
            :items="['Tutor', 'Normal']"
            label="Escolha o modo"
            class="pl-10 pr-10 pt-3 mx-auto"
          ></v-select>

          <v-autocomplete
            v-if="isTecmAdmin && pastExamsOptions.length > 0"
            v-model="selectedPastExams"
            :items="pastExamsOptions"
            label="Filtrar por provas passadas (opcional)"
            multiple
            clearable
            chips
            closable-chips
            class="pl-10 pr-10 pt-3 mx-auto"
            placeholder="Selecione as provas passadas..."
          ></v-autocomplete>

          <!-- checkbox para carregar apenas questões erradas -->
          <v-checkbox
            v-model="onlyWrongQuestions"
            class="pl-10 pr-10 pt-2 mx-auto"
            label="Realizar apenas questões que errei"
            hide-details
          ></v-checkbox>

          <!-- checkbox para carregar apenas questões inéditas -->
          <v-checkbox
            v-model="onlyNewQuestions"
            class="pl-10 pr-10 pt-2 mx-auto"
            label="Realizar apenas questões inéditas (não respondidas)"
            hide-details
          ></v-checkbox>

          <v-card-text v-if="selectedMode === 'Tutor'" class="pl-10 pr-10 pt-0 mt-3 mx-auto">
            No modo Tutor, as respostas e resoluções são exibidas logo após cada pergunta.
          </v-card-text>
          <v-card-text v-if="selectedMode === 'Normal'" class="pl-10 pr-10 pt-0 mt-3 mx-auto">
            No modo Normal, as respostas e resoluções ficam disponíveis apenas no final do simulado.
          </v-card-text>
          <v-card-text v-if="onlyWrongQuestions === true" class="pl-10 pr-10 pt-0 mt-1 mx-auto">
            Refaça apenas as questões que você não acertou nos testes anteriores de acordo com o tema escolhido.
          </v-card-text>
          <v-card-text v-if="onlyNewQuestions === true" class="pl-10 pr-10 pt-0 mt-1 mx-auto">
            Realize apenas questões que você ainda não respondeu neste banco.
          </v-card-text>

          <v-card-actions class="d-flex justify-center pb-6">
            <v-btn
              :disabled="selectedNumberOfQuestions > 90 || selectedNumberOfQuestions < 1 || selectedTheme == ''"
              variant="elevated"
              class="vs-btn-primary"
              style="width: 220px; height: 44px; font-size: 15px; color: white !important; border-radius: 10px; text-transform: none; font-weight: 600; letter-spacing: 0.02em;"
              @click="startQuiz"
              color="primary"
            >Iniciar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { onMounted, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
// import supabase client
import { supabase } from '@/plugins/supabase';

export default {
  name: 'QuizSetup',
  props: {
    noqdName: Number,
    noqName: Number,
    loadThemes: Array,
  },
  setup(props, { emit }) {
    const store = useStore();
// --- ADICIONE ESTAS LINHAS AQUI ---
    const showNoQuestionsDialog = ref(false);
    const noQuestionsMessage = ref('');
    // ---------------------------------
    // Variáveis reativas
    const showChallengeDialog = ref(false); // Controla a exibição do diálogo do desafio

    // Pesquisa NPS (ativa até 11/11)
    const isNpsSurveyActive = () => {
      const now = new Date();
      const deadline = new Date(2026, 10, 11, 23, 59, 59, 999);
      if (now.getFullYear() === 2026) {
        return now <= deadline;
      }
      const currentYearDeadline = new Date(now.getFullYear(), 10, 11, 23, 59, 59, 999);
      return now.getMonth() === 10 && now <= currentYearDeadline;
    };

    const isTemfcUser = computed(() => {
      const admin = (store.state.admin || '').toLowerCase().trim();
      const temfcList = ['temfc', 'temfcadmin', 'kit_temfc', 'kit_temfcadmin', 'kit_temfc_admin', 'kit-temfc', 'kit-temfcadmin', 'kit-temfc-admin', 'kittemfc', 'kittemfcadmin'];
      return temfcList.includes(admin) || String(store.getters.dbName || '').toUpperCase().includes('TEMFC');
    });

    const isNpsActive = computed(() => isNpsSurveyActive());
    const showNpsDialog = ref(false);

    const checkNpsDialog = () => {
      if (!isTemfcUser.value) {
        showNpsDialog.value = false;
        return;
      }
      if (!isNpsActive.value) {
        showNpsDialog.value = false;
        return;
      }
      const responded = localStorage.getItem('nps_edital38_responded') || sessionStorage.getItem('nps_edital38_responded');
      const dismissed = sessionStorage.getItem('nps_edital38_dismissed');
      if (!responded && !dismissed) {
        showNpsDialog.value = true;
      }
    };

    const respondNpsNow = () => {
      localStorage.setItem('nps_edital38_responded', 'true');
      sessionStorage.setItem('nps_edital38_responded', 'true');
      showNpsDialog.value = false;
      window.open('https://form.medexperts.com.br/npsedital38', '_blank');
    };

    const dismissNpsDialog = () => {
      sessionStorage.setItem('nps_edital38_dismissed', 'true');
      showNpsDialog.value = false;
    };
    const quizstart = ref(false);
    const selectedNumberOfQuestions = ref(1);
    const selectedTheme = ref(['Todos']);
    const selectedSubTheme = ref(['Todos']);
    const selectedMode = ref('Tutor');
    const onlyWrongQuestions = ref(false);          // << adicionado
    const onlyNewQuestions = ref(false);            // << adicionado
    const selectedPastExams = ref([]);

    // Supabase data refs (usar Questions_qBank em vez do store)
    const questions = ref([]); // <-- agora contém os itens vindos de Questions_qBank
    const supabaseError = ref(null);
    const hasLoadedInitialItems = ref(false);

    const loadInitialQuestionsData = async () => {
      if (hasLoadedInitialItems.value) return;

      const adminValue = store.state.admin;
      if (typeof adminValue === 'string' && adminValue.includes(',')) {
        return;
      }

      hasLoadedInitialItems.value = true;
      // Removido store.dispatch('loadItems') para evitar chamadas duplas, pois o WebApp.vue já faz isso.
    };

    // existing computed / watchers
    const loading = computed(() => store.getters.loading);
    const dbName = computed(() => store.getters.dbName);
    // mostrar "TEMFC" quando o usuário for temfcadmin ou temfc, caso contrário "AGSUS"
    const displayDbName = computed(() => {
      if (store.state.admin === 'temfcadmin' || store.state.admin === 'temfc') {
        return 'TEMFC';
      } else if (store.state.admin === 'agsusadmin' || store.state.admin === 'agsus') {
        return 'AGSUS';
      } else if (store.state.admin === 'tecmadmin' || store.state.admin === 'tecm') {
        return 'TECM';
      } else if (store.state.admin === 'kit_temfcadmin' || store.state.admin === 'kit_temfc') {
        return 'Kit-TEMFC';
      } else {
        return '';
      }
    });
    const challengeProgress = computed(() => store.getters.challengeProgress);
    const questoesRespondidas = computed(() => store.getters.questoesRespondidas);
    const questoesErradas = computed(() => store.getters.questoesErradas);
    const isTecmAdmin = computed(() => ['tecmadmin', 'tecm'].includes(store.state.admin));

    const extractPastExam = (questionText) => {
      if (!questionText) return null;
      const plainText = String(questionText).replace(/<[^>]*>?/gm, '').trim();
      const match = plainText.match(/^\(\s*TECM\s+(\d{4})\s*\)/i);
      return match ? `(TECM ${match[1]})` : null;
    };

    const pastExamsOptions = computed(() => {
      if (!isTecmAdmin.value) return [];
      const exams = new Set();
      questions.value.forEach((question) => {
         const exam = extractPastExam(question.question);
         if (exam) exams.add(exam);
      });
      return Array.from(exams).sort();
    });

    // loadThemes agora usa `questions` em vez do store
    const themeOptions = computed(() => {
      const themes = new Set(['Todos']);
      const wrongList = (questoesErradas.value || []).map(String);
      const answeredList = (questoesRespondidas.value || []).map(String);
      
      questions.value.forEach((question) => {
        // Se estiver no modo "apenas erradas", filtra apenas questões erradas
        if (onlyWrongQuestions.value && !wrongList.includes(String(question.questionId))) {
          return;
        }

        // Se estiver no modo "apenas inéditas", filtra apenas não respondidas
        if (onlyNewQuestions.value && answeredList.includes(String(question.questionId))) {
          return;
        }

        if (isTecmAdmin.value && selectedPastExams.value.length > 0) {
          const exam = extractPastExam(question.question);
          if (!exam || !selectedPastExams.value.includes(exam)) {
            return;
          }
        }
        
        if (question.questionTheme && question.questionTheme !== '') {
          themes.add(question.questionTheme);
        }
      });
      return Array.from(themes);
    });

    const loadSubThemes = computed(() => {
      const subThemes = new Set(['Todos']);
      const wrongList = (questoesErradas.value || []).map(String);
      const answeredList = (questoesRespondidas.value || []).map(String);
      
      questions.value.forEach((question) => {
        // Se estiver no modo "apenas erradas", filtra apenas questões erradas
        if (onlyWrongQuestions.value && !wrongList.includes(String(question.questionId))) {
          return;
        }

        // Se estiver no modo "apenas inéditas", filtra apenas não respondidas
        if (onlyNewQuestions.value && answeredList.includes(String(question.questionId))) {
          return;
        }
        
        if (isTecmAdmin.value && selectedPastExams.value.length > 0) {
          const exam = extractPastExam(question.question);
          if (!exam || !selectedPastExams.value.includes(exam)) {
            return;
          }
        }

        const matchesTheme = selectedTheme.value.includes('Todos') || selectedTheme.value.includes(question.questionTheme);
        if (matchesTheme && question.questionSubTheme && question.questionSubTheme !== '') {
          subThemes.add(question.questionSubTheme);
        }
      });
      return Array.from(subThemes);
    });

   onMounted(async () => {
      const currentAdmin = (store.state.admin || '').toLowerCase().trim();
      const kitList = ['kit_temfc', 'kit_temfcadmin', 'kit_temfc_admin', 'kit-temfc', 'kit-temfcadmin', 'kit-temfc-admin', 'kittemfc', 'kittemfcadmin'];
      if (kitList.includes(currentAdmin)) {
        router.replace('/webapp/questionssimulado');
        return;
      }
      await loadInitialQuestionsData();
      checkNpsDialog();

      // Acessa o getter
      const questoesRespondidas = store.getters.questoesRespondidas;
      const questoesErradas = store.getters.questoesErradas;
      console.log('Questões Respondidas:', questoesRespondidas);
      console.log('Questões Erradas:', questoesErradas);
    });

    // Remova o onMounted que carrega do Supabase

    // Adicione este watcher dentro do setup:
    watch(
      () => store.state.admin,
      async (newAdmin) => {
        if (!newAdmin) {
          console.log('[supabase] store.state.admin não definido, não carregando dados.');
          return;
        }

        const adminNorm = (newAdmin || '').toLowerCase().trim();
        const kitList = ['kit_temfc', 'kit_temfcadmin', 'kit_temfc_admin', 'kit-temfc', 'kit-temfcadmin', 'kit-temfc-admin', 'kittemfc', 'kittemfcadmin'];
        if (kitList.includes(adminNorm)) {
          router.replace('/webapp/questionssimulado');
          return;
        }

        await loadInitialQuestionsData();

        if (['tecmadmin', 'tecm'].includes(newAdmin)) {
          showChallengeDialog.value = false;
          showNpsDialog.value = false;
          console.log('[desafio] ocultando card para admin TECM');
        } else {
          checkNpsDialog();
        }
        try {
          // escolher a tabela com base no admin
          let tableName = 'Questions_qBank';
          if (['tecmadmin', 'tecm'].includes(store.state.admin)) {
            tableName = 'Questions_qBank_TECM';
          } else if (['kit_temfcadmin', 'kit_temfc'].includes(store.state.admin)) {
            tableName = 'Questions_qBank_kit';
          }
          const { data, error } = await supabase.from(tableName).select('*');
          console.log('[supabase] tabela consultada:', tableName);
          if (error) {
            console.error('[supabase] erro:', error);
            supabaseError.value = error;
          } else {
            // 1. Função para embaralhar os dados
            const shuffleArray = (array) => {
              for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
              }
              return array;
            };

            // 2. Filtrar questões exclusivas do AgSUS
            const isTemfcCourse = ['temfcadmin', 'temfc', 'kit_temfcadmin', 'kit_temfc'].includes(store.state.admin);
            let filteredData = data.filter((row) => {
              const exclusivoAgSUS = row['Exclusivo AgSUS?']?.toLowerCase() === 'sim';
              if (isTemfcCourse && exclusivoAgSUS) {
                return false; // Ignorar questões exclusivas do AgSUS
              }
              return true;
            });

            const isFreemium = store.getters.freemium === 'true' || store.getters.freemium === true;
            const isAdminTemfc = isTemfcCourse;

            // Limitar a 50% para usuários Freemium (exceto TEMFC)
            if (isFreemium && !isAdminTemfc) {
              const limitCount = Math.floor(filteredData.length / 2);
              filteredData = filteredData.slice(0, limitCount);
            }

            // 3. Embaralhar os dados filtrados
            const shuffledData = shuffleArray(filteredData);

            // 4. Normalizar os registros para o formato esperado pela UI
            const normalized = shuffledData.map((row) => {
              const get = (...keys) => {
                for (const k of keys) {
                  if (row[k] !== undefined && row[k] !== null) return row[k];
                }
                return null;
              };

              let questionId = get('questionId', 'question_id', 'id', 'qid');
              let question = get('question', 'question_text', 'text', 'q');
              let questionImage = get('questionImage', 'image', 'img', 'picture');
              let questionAnswer = get('questionAnswer', 'answer', 'correct', 'gabarito');
              let questionComment = get('questionComment', 'comment', 'explanation', 'resolucao');
              let questionVideo = get('questionVideo', 'video', 'youtube');
              let questionTheme = get('questionTheme', 'theme', 'tema');
              let questionSubTheme = get('questionSubTheme', 'subtheme', 'sub_theme', 'sub_tema');

              const optionCandidates = [
                'questionOptions', 'options', 'question_options',
                'option1', 'option2', 'option3', 'option4', 'option5',
                'opt1', 'opt2', 'opt3', 'opt4', 'opt5',
                'a', 'b', 'c', 'd', 'e',
                'option_a', 'option_b', 'option_c', 'option_d', 'option_e'
              ];

              let questionOptions = [];
              const rawOpts = get(...optionCandidates);
              if (Array.isArray(rawOpts)) {
                questionOptions = rawOpts.filter(o => o != null && String(o).trim() !== '');
              } else if (typeof rawOpts === 'string' && rawOpts.trim() !== '') {
                if (rawOpts.includes('|')) questionOptions = rawOpts.split('|').map(s => s.trim()).filter(Boolean);
                else if (rawOpts.includes(';')) questionOptions = rawOpts.split(';').map(s => s.trim()).filter(Boolean);
                else if (rawOpts.includes(',')) questionOptions = rawOpts.split(',').map(s => s.trim()).filter(Boolean);
                else questionOptions = [rawOpts.trim()];
              }

              const values = Object.values(row || []).map(v => v === null || v === undefined ? '' : String(v));
              const hasMeaningfulValue = values.some(v => v.trim() !== '');
              if ((!question && !questionId && questionOptions.length === 0) && hasMeaningfulValue) {
                questionId = questionId ?? (values[0] || null);
                question = question ?? (values[1] || '');
                const opt2 = values[2] || '';
                const opt3 = values[3] || '';
                const opt4 = values[4] || '';
                const opt5 = values[5] || '';
                const opt6 = values[6] || '';
                questionOptions = [opt2, opt3, opt4, opt5, opt6].map(s => s.trim()).filter(Boolean);
                questionImage = questionImage ?? (values[7] || null);
                questionAnswer = questionAnswer ?? (values[8] || null);
                questionComment = questionComment ?? (values[9] || null);
                questionVideo = questionVideo ?? (values[10] || null);
                questionTheme = questionTheme ?? (values[11] || null);
                questionSubTheme = questionSubTheme ?? (values[12] || null);
              }

              return {
                questionId: questionId ?? null,
                question: question ?? '',
                questionOptions,
                questionImage: questionImage ?? null,
                questionAnswer: questionAnswer ?? null,
                questionComment: questionComment ?? null,
                questionVideo: questionVideo ?? null,
                questionTheme: questionTheme ?? null,
                questionSubTheme: questionSubTheme ?? null,
                ...row
              };
            });

            // Filtrar temas se for Freemium e TEMFC
            let finalData = normalized;
            if (isFreemium && isAdminTemfc) {
              const allowedThemes = [
                'Atenção a populações específicas',
                'Abordagem a problemas infecciosos',
                'Rastreamento e prevenção'
              ];
              finalData = finalData.filter((q) => {
                const themeStr = q.questionTheme ? q.questionTheme.trim() : '';
                return allowedThemes.includes(themeStr);
              });
            }

            console.log('[supabase] dados (final):', finalData);
            questions.value = finalData;
          }
        } catch (err) {
          console.error('[supabase] exception:', err);
          supabaseError.value = err;
        }
      },
      { immediate: true }
    );

    // Métodos
    const showQuestionResetDialog = ref(false);
    const openQuestionResetDialog = () => {
      showQuestionResetDialog.value = true;
      console.log('Abrindo diálogo de reset de questões');
    };
    const closeSuggestionDialog = () => {
      showQuestionResetDialog.value = false;
      console.log('Abrindo diálogo de reset de questões');
    };
    const resetting = ref(false);

    // abrir automaticamente o diálogo do desafio quando challengeProgress for menor que 150 (se NPS não estiver ativo)
    watch(challengeProgress, (val) => {
      if (isNpsActive.value || !isTemfcUser.value) {
        showChallengeDialog.value = false;
        if (isNpsActive.value) {
          checkNpsDialog();
        }
        return;
      }

      if (typeof val === 'number' && val < 150) {
        showChallengeDialog.value = true;
        console.log('Mostrando diálogo do desafio: challengeProgress=', val);
      } else {
        showChallengeDialog.value = false;
        console.log('Fechando diálogo do desafio: challengeProgress=', val);
      }
    }, { immediate: true });

    watch(onlyWrongQuestions, (val) => {
      if (val) onlyNewQuestions.value = false;
    });

    watch(onlyNewQuestions, (val) => {
      if (val) onlyWrongQuestions.value = false;
    });

    const saveQuestionReset = () => {
      resetting.value = true;
      console.log('resetando');
      store.dispatch('saveQuestionReset')
        .then(() => {
          setTimeout(() => {
            store.dispatch("loadItems");
          }, 1000);
          setTimeout(() => {
            resetting.value = false;
          }, 5000);
        })
        .catch(error => {
          console.error("Erro ao salvar item:", error);
        });
      closeSuggestionDialog();
    };

    const normalizeSelection = (newVal) => {
      const selection = Array.isArray(newVal) ? [...newVal] : [newVal];
      if (selection.includes('Todos') && selection.length > 1) {
        const todosIndex = selection.indexOf('Todos');
        selection.splice(todosIndex, 1);
      } else if (selection.length === 0) {
        selection.push('Todos');
      }
      return selection;
    };

    const handleThemeSelectionChange = (newVal) => {
      selectedTheme.value = normalizeSelection(newVal);
      console.log('Tema selecionado:', selectedTheme.value);
    };

    const handleSubThemeSelectionChange = (newVal) => {
      selectedSubTheme.value = normalizeSelection(newVal);
      console.log('Subtema selecionado:', selectedSubTheme.value);
    };

    const router = useRouter();
    const startQuiz = async () => {
      let filteredItems = [];
      const blacklist = questoesRespondidas.value || [];
      const wrongList = (questoesErradas.value || []).map(String);

      questions.value.forEach(item => {
        if (filteredItems.length >= selectedNumberOfQuestions.value) return;

        // se estiver filtrando apenas erradas, pula quem não está na lista
        if (onlyWrongQuestions.value && !wrongList.includes(String(item.questionId))) {
          return;
        }

        // se estiver filtrando apenas inéditas, pula se o questionId está na blacklist
        if (onlyNewQuestions.value && !onlyWrongQuestions.value && blacklist.includes(String(item.questionId))) {
          console.log('Pulando questão respondida (inédita requerida):', item.questionId);
          return;
        }

        const matchesTheme = selectedTheme.value.includes('Todos') || selectedTheme.value.includes(item.questionTheme);
        const matchesSubTheme = selectedSubTheme.value.includes('Todos') || selectedSubTheme.value.includes(item.questionSubTheme);

        // Filtro de provas passadas
        let matchesPastExam = true;
        if (isTecmAdmin.value && selectedPastExams.value.length > 0) {
          const exam = extractPastExam(item.question);
          if (!exam || !selectedPastExams.value.includes(exam)) {
            matchesPastExam = false;
          }
        }

        if (matchesTheme && matchesSubTheme && matchesPastExam) {
          filteredItems.push(item);
        }
      });

      if (filteredItems.length === 0) {
        let temaMsg = selectedTheme.value.join(', ');
        if (onlyWrongQuestions.value) {
          noQuestionsMessage.value = `Não há questões erradas disponíveis${ temaMsg ? ' no(s) tema(s) "'+temaMsg+'"' : '' }! 🎉`;
        } else {
          noQuestionsMessage.value = `Todas as questões do tema "${temaMsg}" já foram respondidas! 🎉`;
        }
        showNoQuestionsDialog.value = true;
        console.log('Nenhuma questão disponível para este tema');
        return;
      }

      console.log('Itens filtrados (sem as respondidas):', filteredItems);

      emit('start-quiz', {
        items: filteredItems,
        mode: selectedMode.value,
      });

      router.push({
        name: 'QuestionsQuiz',
        query: {
          mode: selectedMode.value,
          items: JSON.stringify(filteredItems),
          isReview: onlyWrongQuestions.value
        },
      });
    };

    // Fechar o diálogo
    const closeNoQuestionsDialog = () => {
      showNoQuestionsDialog.value = false;
    };

    return {
      quizstart,
      showChallengeDialog,
      isTemfcUser,
      isNpsActive,
      showNpsDialog,
      respondNpsNow,
      dismissNpsDialog,
      displayDbName,
      showQuestionResetDialog,
      selectedNumberOfQuestions,
      selectedTheme,
      selectedSubTheme,
      selectedMode,
      resetting,
      dbName,
      openQuestionResetDialog,
      closeSuggestionDialog,
      saveQuestionReset,
      handleThemeSelectionChange,
      handleSubThemeSelectionChange,
      startQuiz,
      themeOptions,
      loadSubThemes,
      loading,
      challengeProgress,
      questoesRespondidas,
      questoesErradas,
      showNoQuestionsDialog,
      noQuestionsMessage,
      closeNoQuestionsDialog,
      onlyWrongQuestions,
      onlyNewQuestions,
      isTecmAdmin,
      selectedPastExams,
      pastExamsOptions,
    };
  },
  watch: {
    challengeProgress(newValue) {
      console.log('challengeProgress atualizado:', newValue);
    }
  }
};
</script>


<style scoped>
/* Estilos opcionais */
</style>